import {
  DTODesignTokenGroupCreatePayload,
  DTODesignTokenGroupListResponse,
  DTODesignTokenGroupResponse,
} from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class TokenGroupsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  create(dsId: string, versionId: string, body: DTODesignTokenGroupCreatePayload) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/token-groups`,
      DTODesignTokenGroupResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  list(dsId: string, versionId: string): Promise<DTODesignTokenGroupListResponse> {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/token-groups`,
      DTODesignTokenGroupListResponse
    );
  }
}
